<template>
  <el-form
    :model="user_data"
    label-position="top"
    ref="user_data"
    :rules="rules"
  >
    <div class="card-header bg-info">
      <h5 class="text-info">
        <i class="fas fa-info-circle"></i> ¿Por qué pedimos tus datos?
      </h5>
      <p class="text-info small m-0" v-html="texts['1_header']"></p>
    </div>

    <div class="card-body border-bottom bg-light">
      <h4 class="m-0"><i class="far fa-user"></i> Datos del estudiante</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 col-lg">
          <el-form-item label="Nombre" prop="name">
            <div>
              <el-input
                placeholder="Nombre"
                name="name"
                v-model="user_data.name"
              ></el-input>
            </div>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg">
          <el-form-item label="Apellidos" prop="surname">
            <div>
              <el-input
                placeholder="Apellidos"
                name="surname"
                v-model="user_data.surname"
              ></el-input>
            </div>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg">
          <el-form-item label="NIF" prop="cif">
            <div>
              <el-input placeholder="NIF" name="cif" v-model="user_data.cif"></el-input>
            </div>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg">
          <el-form-item label="Fecha de nacimiento" prop="birthdate">
            <div>
              <el-date-picker
                type="date"
                name="date"
                placeholder="Selecciona tu fecha de nacimiento"
                v-model="user_data.birthdate"
              ></el-date-picker>
            </div>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg">
          <el-form-item label="Email" prop="email">
            <div>
              <el-input
                placeholder="Email"
                name="email"
                v-model="user_data.email"
              ></el-input>
            </div>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg">
          <el-form-item label="Teléfono" prop="phone">
            <div>
              <el-input
                placeholder="Teléfono"
                name="phone"
                v-model="user_data.phone"
              ></el-input>
            </div>
          </el-form-item>
        </div>
        <div class="col-12">
          <p class="m-0" v-if="type === 1">
            Resultado test de nivel:
            <span class="badge bg-success text-white">{{ level }}</span>
          </p>
          <el-form-item label="Selecciona el nivel que quieres preparar" prop="level" v-else>
            <el-select
              v-model="user_data.level"
              placeholder="Elige el nivel que te quieres preparar"
              class="w-100 mt-1 placeholde-dark"
              style="margin-bottom: 10px"
            >
              <el-option
                v-for="item in optionsLevels"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>

    <div class="card-body bg-light text-right border-top">
      <el-button
        style="width: 100%; max-width: 200px"
        type="primary"
        plain
        @click="sendFormUser('user_data')"
      >
        SIGUIENTE <i class="el-icon-arrow-right el-icon-right"></i>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  props: ["level", "old_user_data", "texts", "type"],
  data() {
    return {
      fullscreenLoading: false,
      user_id: null,
      user_data: {
        name: "",
        surname: "",
        cif: "",
        birthdate: new Date(),
        email: "",
        phone: "",
        level: "",
      },
      reservation_id: null,
      degrees: [],
      optionsLevels: [
        { value: "A1", label: "A1" },
        { value: "A2", label: "A2" },
        { value: "B1", label: "B1" },
        { value: "B2", label: "B2" },
        { value: "C1/C2", label: "C1" },
        { value: "C2", label: "C2" },
      ],
      rules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
        surname: [
          {
            required: true,
            message: "Please input surname",
            trigger: "change",
          },
        ],
        cif: [
          {
            required: true,
            message: "Please input cif",
            trigger: "blur",
          },
        ],
        birthdate: [
          {
            required: true,
            message: "Please pick your birth date",
            trigger: "change",
          },
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "Please input email",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "Please input phone number",
            trigger: "blur",
          },
        ],
        level: [
          {
            required: this.type === 2 ? true : false,
            message: "Please select your level",
            trigger: "change",
          },
        ]
      },
    };
  },
  created() {
    this.user_data = this.old_user_data
  },
  methods: {
    sendFormUser(user_data) {
      this.$refs[user_data].validate((valid) => {
        if (valid) {
          axios
            .get("/api/reservation/check-user?email=" + this.user_data.email)
            .then((res) => {
              // Le asignamos un valor cualquiera a this.reservation.userId para avanzar al siguiente paso del formulario
              // this.reservation.userId = 1;
              // this.reservation.userExist = res.data.user_exist;
              this.$emit("sendFormData", this.user_data, res.data.user_exist);
            })
            .catch((e) => {
              console.log(e);
              this.$message({
                message: 'Error al enviar formulario, contacte con administración',
                type: "warning",
                duration: 3000,
              });
            });
        }
      });
    },
  },
};
</script>

<style type="text/css" scoped>
.bg-info {
  background: #ecf5ff !important;
}
.text-info {
  color: #409eff !important;
}
</style>
